import { FormControl, makeStyles, MenuItem, Select } from '@material-ui/core';
import React from 'react';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { COLORS } from '../../plTheme';

export interface WeeklyDropDownProps {
  selectedWeek: any;
  handleChange: any;
  weeks: any;
  width?: number;
  title?: string;
  currentWeekNumber: any;
  disabled?: boolean;
}

const WeeklyDropDown: React.FC<WeeklyDropDownProps> = (
  props: WeeklyDropDownProps
) => {
  const {
    selectedWeek,
    handleChange,
    weeks,
    width = 224,
    title,
    currentWeekNumber,
    disabled = false,
  } = props;
  const useStyles = makeStyles({
    formControl: {
      width: width,
      borderRadius: 8,
    },
    quantityRoot: {
      '& .MuiOutlinedInput-notchedOutline': {
        border: 0,
        borderRadius: '2px',
      },
      '& .Mui-focused .MuiOutlinedInput-notchedOutline': {
        border: 0,
        borderRadius: '2px',
      },
      '&:hover .MuiOutlinedInput-notchedOutline': {
        border: 0,
        borderRadius: '2px',
      },
    },
    dropDown: {
      height: 38,
      border: '1.4px solid #D7DFE9',
      borderRadius: 7,
      width: width, //375,
      padding: '3px 0 2px !important',
    },
    rightSubHeading: {
      'font-family': 'Rubik',
      'font-style': 'normal',
      'font-weight': 500,
      'font-size': 16,
      width: `${width} !important`,
    },
    icon: {
      paddingLeft: 3,
      color: '#171f46',
    },
    selectRoot: {
      color: '#171f46',
      '&:focus': {
        backgroundColor: 'transparent',
      },
    },
    selectRootDisabled: {
      color: '#00000042',
      '&:focus': {
        backgroundColor: 'transparent',
      },
    },
    iconDisabled: {
      paddingLeft: 3,
      color: '#00000042',
    },
    selectMenuDisabled: {
      color: '#00000042',
    },
    // icon: {
    //   paddingLeft: 3,
    //   color: selectedWeek === -1 ? '#171f46' : 'white',
    // },
    // selectRoot: {
    //   color: selectedWeek === -1 ? '#171f46' : 'white',
    //   '&:focus': {
    //     backgroundColor: 'transparent',
    //   },
    // },
  });

  const classes = useStyles();

  return (
    <div>
      <FormControl
        variant="outlined"
        className={classes.formControl}
        classes={{
          root: classes.quantityRoot,
        }}
        style={{
          backgroundColor: disabled ? '#f5f5f5' : 'white',
        }}
        disabled={disabled}
      >
        <Select
          IconComponent={ExpandMoreIcon}
          disabled={disabled}
          className={`${classes.dropDown} ${classes.rightSubHeading}`}
          value={selectedWeek}
          onChange={handleChange}
          style={disabled ? { color: '#00000042' } : undefined}
          classes={{
            selectMenu: disabled ? classes.selectMenuDisabled : undefined,
            icon: disabled ? classes.iconDisabled : undefined,
          }}
          inputProps={{
            classes: {
              icon: disabled ? classes.iconDisabled : classes.icon,
              root: disabled ? classes.selectRootDisabled : classes.selectRoot,
            },
          }}
          MenuProps={{
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            transformOrigin: {
              vertical: 'top',
              horizontal: 'left',
            },
            getContentAnchorEl: null,
            PaperProps: {
              style: {
                maxHeight: 13 * 29, // 13 items * 48px (default MenuItem height)
                overflow: 'auto',
              },
            },
          }}
        >
          <MenuItem
            className={classes.rightSubHeading}
            value={-1}
            disabled
            style={{ color: '#999', fontSize: 14, paddingLeft: 12 }}
          >
            {title}
          </MenuItem>
          {weeks.map((element: any) => (
            <MenuItem
              className={classes.rightSubHeading}
              value={element.value}
              style={{ paddingLeft: 12 }}
              key={`title${element.value}`}
              disabled={
                element?.isDisabled
                  ? element?.isDisabled
                  : element?.skipCurrentWeekCheck
                  ? false
                  : !currentWeekNumber
                  ? false
                  : element.value > currentWeekNumber
              }
            >
              {element.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </div>
  );
};

export default WeeklyDropDown;
